import axios from "axios";
import {API_DOMAIN} from "../constants";

export async function getReps(
    businessUnitCode,
    activated,
    salesRegion,
    salesTerritory,
    page,
    size,
    searchString,
    facilityId,
    userTypeId
) {
    let params = {
        businessUnitCode: businessUnitCode,
        salesRegion: salesRegion,
        salesTerritory: salesTerritory,
        // authority: "ROLE_EXP_REP",
        activated: activated,
        searchString: searchString,
        page: page,
        size: size,
        facilityId,
        userTypeId,
    };
    if (!businessUnitCode) {
        delete params.businessUnitCode;
    }
    if (!userTypeId) {
        delete params.userTypeId;
    }
    if (!salesRegion) {
        delete params.salesRegion;
    }
    if (!salesTerritory) {
        delete params.salesTerritory;
    }
    if (!facilityId) {
        delete params.facilityId;
    }
    const response = await axios({
        url: API_DOMAIN + "/api/v2/users",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params,
    });

    return {reps: response.data, totalCount: parseInt(response.headers["x-total-count"])};
}

export async function getBusinessUnitCodes() {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/user/current/businessUnitCodes",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}

export async function createUser(payload) {
    return axios({
        url: API_DOMAIN + "/api/v2/users",
        method: "POST",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}

export async function updateUser(payload) {
    return axios({
        url: API_DOMAIN + "/api/v2/users",
        method: "PUT",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}

export async function getUser(userId) {
    const response = await axios({
        url: API_DOMAIN + `/api/v2/users/${userId}/adminPortal`,
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}

// POST /api/v3/auth/users — authz-aware create (fitting pass-through to AuthService). The caller
// authenticates with their normal admin-portal session; fitting attaches the service credentials.
export async function createAuthUser(payload) {
    return axios({
        url: API_DOMAIN + "/api/v3/auth/users",
        method: "POST",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}

// GET /api/v3/auth/users/{id} — full authorization-aware detail (identity, classification, groups
// each with their claims, individually-assigned claims, conditional details + sales region/
// territories composed by the fitting pass-through). Delivered by TMMFX-3451.
export async function getAuthUser(id) {
    const response = await axios({
        url: API_DOMAIN + `/api/v3/auth/users/${id}`,
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}

// PUT /api/v3/auth/users/{id} — atomic update. Payload mirrors createAuthUser (login/email immutable);
// individualClaims is the full desired set (replace semantics). Delivered by TMMFX-3451.
export async function updateAuthUser(id, payload) {
    return axios({
        url: API_DOMAIN + `/api/v3/auth/users/${id}`,
        method: "PUT",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}

export async function getUserByLogin(login) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/users/adminPortal",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {login},
    });

    return response.data;
}

// GET /api/v3/auth/users?search=&businessUnitCode= — user search by login / name / email (each row's
// territoryCount comes from the identity service). businessUnitCode is optional. Delivered by
// TMMFX-2171.
export async function searchAuthUsers(search, businessUnitCode) {
    const params = {search};
    if (businessUnitCode) {
        params.businessUnitCode = businessUnitCode;
    }
    const response = await axios({
        url: API_DOMAIN + "/api/v3/auth/users",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params,
    });

    return response.data;
}
